export interface AWBActionTypes {
  type: AWBActions;
  payload?: any;
}

export enum AWBActions {
  SET_CUSTOMER = "SET_CUSTOMER",
  SET_VENDOR = "SET_VENDOR",
  SET_BRANCH = "SET_BRANCH",
  SET_AWB_STATE = "SET_AWB_STATE",
  SET_BOOKING_DATE_RANGE = "SET_BOOKING_DATE_RANGE",  
}
